const CHANNEL_NAME = 'order_broadcast_channel';
const STORAGE_KEY = 'order_broadcast_data';

const EMPTY_ORDER_DATA = {
    orderItems: [],
    totals: {
        subtotal: 0,
        vat: 0,
        grandTotal: 0,
    },
    customer: null,
    orderDate: '',
};

class OrderBroadcastService {
    constructor() {
        this.channel = null;

        if (typeof window === 'undefined') {
            return;
        }

        if ('BroadcastChannel' in window) {
            this.channel = new BroadcastChannel(CHANNEL_NAME);
        }
    }

    broadcast(data) {
        if (typeof window !== 'undefined') {
            try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
            } catch (error) {
                console.error('Failed to save order broadcast data to localStorage:', error);
            }
        }

        if (this.channel) {
            this.channel.postMessage(data);
        }
    }

    getStoredData() {
        if (typeof window === 'undefined') {
            return EMPTY_ORDER_DATA;
        }

        try {
            const data = localStorage.getItem(STORAGE_KEY);
            return data ? JSON.parse(data) : EMPTY_ORDER_DATA;
        } catch (error) {
            console.error('Failed to retrieve order broadcast data from localStorage:', error);
            return EMPTY_ORDER_DATA;
        }
    }

    subscribe(callback) {
        if (this.channel) {
            const handler = (event) => {
                callback(event.data);
            };

            this.channel.addEventListener('message', handler);

            return () => {
                this.channel?.removeEventListener('message', handler);
            };
        }

        const handler = (event) => {
            if (event.key !== STORAGE_KEY || !event.newValue) {
                return;
            }

            try {
                callback(JSON.parse(event.newValue));
            } catch (error) {
                console.error('Failed to parse order broadcast data:', error);
            }
        };

        window.addEventListener('storage', handler);

        return () => {
            window.removeEventListener('storage', handler);
        };
    }

    clear() {
        if (typeof window !== 'undefined') {
            try {
                localStorage.removeItem(STORAGE_KEY);
            } catch (error) {
                console.error('Failed to clear order broadcast data from localStorage:', error);
            }
        }
        this.broadcast(EMPTY_ORDER_DATA);
    }

    close() {
        this.channel?.close();
        this.channel = null;
    }
}

export const orderBroadcast = new OrderBroadcastService();